/**
 * Use: Global setting to open Shopify's native Cookies banner
 * -----------------------------------------------------------------------------
 */
document.addEventListener('DOMContentLoaded', function () {
  var cookiePreferenceButtons = document.querySelectorAll('.cookie-preference');

  // Loop through all the elements with the class 'cookie-preference'
  cookiePreferenceButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      Optanon.ToggleInfoDisplay();
    });
  });
});
